export default __webpack_public_path__ + "static/media/appleQRCode.0c688118.svg";